import axios from "axios";

if (window.localStorage.vuex != undefined) {
  const LocalDataVuex = JSON.parse(window.localStorage.vuex);
  var token = LocalDataVuex.token;
}
const CancelToken = axios.CancelToken;
let cancel;

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT,
  timeout: 20000,
  headers: {
    Authorization: `Bearer ` + token,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  cancelToken: new CancelToken(function executor(c) {
    cancel = c;
  }),
});

const instanceMultipart = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT,
  timeout: 20000,
  headers: {
    Authorization: `Bearer ` + token,
    Accept: "application/json",
    "Content-Type": "multipart/form-data",
  },
  cancelToken: new CancelToken(function executor(c) {
    cancel = c;
  }),
});

const instanceRkas = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT_RKAS,
  timeout: 20000,
  headers: {
    Authorization: `Bearer ` + token,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  cancelToken: new CancelToken(function executor(c) {
    cancel = c;
  }),
});

const setToken = (value) => {
  let item = localStorage.getItem("token");
  token = item ?? value;
};

export function ApiGetRequest(url, data = {}) {
  return instance
    .get(url, {
      params: data,
    })
    .then((response) => response)
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      return {
        error: (error.response && error.response.data.message) || error,
        errorList:
          error.response && error.response.data && error.response.data.errors,
      };
    });
}

export function ApiPostMultipart(url, data = {}) {
  return instance
    .post(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => response)
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      return {
        error: (error.response && error.response.data.message) || error,
        errorList:
          error.response && error.response.data && error.response.data.errors,
      };
    });
}

export function ApiGetUploadFile(url, data = {}, callbackUpload = () => {}) {
  return instance
    .post(url, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (event) => callbackUpload(event),
    })
    .then((response) => response)
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      return {
        error: (error.response && error.response.data.message) || error,
        errorList:
          error.response && error.response.data && error.response.data.errors,
      };
    });
}

export const ApiPostRequest = (url, data = {}) => {
  return instance
    .post(url, data)
    .then((response) => response)
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      return {
        error: (error.response && error.response.data.message) || error,
        errorList:
          error.response && error.response.data && error.response.data.errors,
      };
    });
};

export const ApiPutRequest = (url, data = {}) => {
  return instance
    .put(url, data)
    .then((response) => response)
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      return {
        error: (error.response && error.response.data.message) || error,
        errorList:
          error.response && error.response.data && error.response.data.errors,
      };
    });
};

export const ApiDeleteRequest = (url, data = {}) => {
  return instance
    .delete(url, data)
    .then((response) => response)
    .then((responseJson) => {
      return responseJson;
    })
    .catch((error) => {
      return {
        error: (error.response && error.response.data.message) || error,
        errorList:
          error.response && error.response.data && error.response.data.errors,
      };
    });
};

export default {
  fetch: instance,
  fetchMultipart: instanceMultipart,
  fetchRkas: instanceRkas,
  cancel,
  setToken,
};
